import { OPEN_PROJECT_UPDATES_MODAL, CLOSE_PROJECT_UPDATES_MODAL } from '../constants/index';

export const openProjectUpdatesModal =
    () =>
    ({ dispatch }) => {
        return dispatch({ type: OPEN_PROJECT_UPDATES_MODAL });
    };
export const closeProjectUpdatesModal =
    () =>
    ({ dispatch }) => {
        return dispatch({ type: CLOSE_PROJECT_UPDATES_MODAL });
    };
